import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(() => ({
  triptychItemWrapper: {
    textAlign: 'center',
    width: 300,
    "@media (max-width: 850px)": {
      width: '100%',
      marginBottom: '40px'
    }
  },
  triptychItemImage: {
    width: 150
  },
  triptychItemText: {
    color: "black",
    fontSize: "14px",
    width: '180px',
    margin: '0 auto'
  }
}));